import axiosInstance from "utils/axios-request";
import {insuranceUrl, gatewayUrl} from "config";

export interface IResponse {
    preSignedUrl: string;
}
export interface  IPreSignedUrl {
    status: number;
    data: IResponse;
}
export const getInsuranceProductsApi = () =>
  axiosInstance.request({
    baseURL: insuranceUrl,
    url: "/products",
    method: "get",
  });

export const getPreSignedUrl = (orderId: string): Promise<IPreSignedUrl> => {
    return axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/insurance-gateway/policy?orderId=${orderId}`,
    method: "get",
    });
};
